import { requireService } from '@profgeosoft/di-ez';
import { ExpandDownLight } from '@repo/go-icons';
import { Collapse } from '@repo/go-ui';
import { clsx } from 'clsx';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { TModelOption } from '../directory-model-service';

import { ModelsListItem } from '../models-list-item/models-list-item';
import styles from '../models-list.module.scss';

export type TModelsGroupKey = 'active' | 'archived';

type Props = {
  groupKey: TModelsGroupKey;
  title: string;
  models: TModelOption[];
  isOpen: boolean;
  onToggle(): void;
};

export const ModelsListGroup = wrap<Props>(function ModelsListGroup({ groupKey, title, models, isOpen, onToggle }) {
  const directoryPage = requireService('directoryPage');
  const { directoryModelService } = directoryPage;

  if (!models.length) {
    return null;
  }

  const isActiveGroup = models.some((model) => model.value === directoryModelService?.currentModelId);

  return (
    <Collapse.Panel
      panelKey={groupKey}
      header={
        <div className={clsx(styles.collapseHeader, isOpen && styles.collapseHeader_open)}>
          <p className={clsx(styles.collapseHeader__text, isActiveGroup && styles.collapseHeader__text_active)}>
            {title}
          </p>
          <ExpandDownLight
            className={clsx(
              styles.collapseIcon,
              isOpen && styles.collapseIcon_open,
              isActiveGroup && styles.collapseIcon_active,
            )}
          />
        </div>
      }
      className={styles.collapse}
      isActive={isOpen}
      onItemClick={onToggle}
    >
      <ul className={styles.list}>
        {models.map((model) => (
          <ModelsListItem key={model.value} model={model} />
        ))}
      </ul>
    </Collapse.Panel>
  );
});
